import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const links = {
    Product: [
      { name: 'Capabilities', path: '/product' },
      { name: 'Solutions', path: '/solutions' },
      { name: 'Marketplace', path: '/marketplace' },
      { name: 'Pricing', path: '/pricing' }
    ],
    Support: [
      { name: 'Documentation', path: '/docs' },
      { name: 'Changelog', path: '/changelog' },
      { name: 'Compliance', path: '/compliance' },
      { name: 'Book Demo', path: '/book-demo' }
    ],
    Legal: [
      { name: 'Privacy Policy', path: '/legal' },
      { name: 'Terms of Service', path: '/legal' },
      { name: 'HIPAA BAA', path: '/legal' },
      { name: 'Security', path: '/compliance' }
    ]
  };

  return (
    <footer className="bg-brand-indigo text-brand-ivory pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-16 mb-20">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-8">
              <div className="w-8 h-8 bg-brand-mint rounded-lg flex items-center justify-center">
                <span className="text-brand-indigo font-bold text-lg">hd</span>
              </div>
              <span className="text-2xl font-display font-bold tracking-tight text-white">
                HDAI Software
              </span>
            </Link>
            <p className="text-white/50 text-lg leading-relaxed max-w-sm mb-8">
              The clinical NLP development environment for high-stakes healthcare engineering.
            </p>
            <div className="flex space-x-4">
              {['Twitter', 'LinkedIn', 'Github'].map(s => (
                <a key={s} href="#" className="w-10 h-10 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center hover:bg-brand-mint hover:text-brand-indigo transition-all">
                  <span className="text-[10px] font-bold uppercase tracking-widest">{s[0]}</span>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(links).map(([cat, items]) => (
            <div key={cat}>
              <h3 className="text-brand-mint font-bold text-xs uppercase tracking-widest mb-6">{cat}</h3>
              <ul className="space-y-4">
                {items.map(link => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-white/60 hover:text-brand-mint transition-colors font-medium">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-white/40 text-sm font-medium">
            &copy; {new Date().getFullYear()} HDAI Software (hdai.software). All rights reserved.
          </div>
          <div className="flex items-center space-x-8 grayscale opacity-50">
            <span className="text-[10px] font-bold tracking-tighter">HIPAA COMPLIANT</span>
            <span className="text-[10px] font-bold tracking-tighter">FDA CDS READY</span>
            <span className="text-[10px] font-bold tracking-tighter">GDPR VERIFIED</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;